<template>
  <div class="login-all-holder">
    <img src="../assets/images/loginbg.jpg" class="bg-img" />
    <b-container fluid class="vertical-aligned">
      <b-card class="login-holder" text-variant="white">
        <div class="img-holder mt-3">
          <img src="../assets/images/pedline-logo.png" />
        </div>
        <b-form>
          <b-form-group id="input-group-1" label="Usuário:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="text"
              required
              placeholder="Digite seu usuário"
              @keyup.enter="login"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Senha:" label-for="input-1">
            <b-form-input
              id="input-2"
              v-model="form.password"
              type="password"
              required
              placeholder="Digite sua senha"
              @keyup.enter="login"
            ></b-form-input>
          </b-form-group>
        </b-form>

        <transition enter-active-class="animated fadeIn">
          <p v-show="warningMessage != ''" class="warning-message">
            {{ warningMessage }}
          </p>
        </transition>

        <b-button
          @click="login"
          class="mt-5 mb-4 btn-login"
          block
          variant="primary"
        >
          <span v-show="!loading">Realizar login</span>
          <b-spinner v-show="loading" type="grow" label="Spinning"></b-spinner>
        </b-button>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import authentication from "../util/authentication";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      warningMessage: "",
      loading: false
    };
  },
  created() {
    document.getElementById("app").style.paddingLeft = 0;
  },
  methods: {
    login() {
      this.warningMessage = "";

      if (this.form.email == "" || this.form.password == "") {
        this.warningMessage = "Por favor, informe seu usuário e senha";
        return;
      }

      this.loading = true;
      authentication
        .login(this.form)
        .then(response => {
          if (response.ok) {
            window.location = "#/post";
          } else {
            this.warningMessage = "Usuário e/ou senha incorreto(s)";
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.warning-message {
  text-align: center;
}
.img-holder {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background: #fff;
  margin: 0 auto;
}

button.btn-login {
  background-color: #8f1542 !important;
  border-color: #751043 !important;
  outline: none !important;
  color: #fff;
}

.img-holder img {
  position: absolute;
  max-width: 90%;
  max-height: 90%;
  top: 50%;
  left: 50%;
  right: 0;
  margin: 0 auto;
  transform: translate3d(-50%, -50%, 0);
}

.login-holder {
  position: relative;
  width: 90%;
  max-width: 480px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #e40084 0%,
    #a02965 46%,
    #531936 100%
  );

  border: none !important;
}

.login-all-holder {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
}
.login-all-holder img.bg-img {
  position: absolute;
  min-width: 100vw;
  min-height: 100vh;
  max-height: 120vh;
  filter: brightness(1.1) blur(4px);
  top: 50%;
  left: 50%;
  right: 0;
  margin: 0 auto;
  transform: translate3d(-50%, -50%, 0);
}

.vertical-aligned {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue